function ComponentMetricsCtrl($scope, $controller, $location, $interval, $filter,$rootScope ){
    var defaultTime = new Date();
    defaultTime.setHours(23);
    defaultTime.setMinutes(59);
    defaultTime.setSeconds(59);
    $scope.fulldata = [];
    $scope.metricdata = [];
    $scope.filtereddata = [];

    $scope.graphinterval = 1000;

    $scope.from = new Date($rootScope.dateRange.start);
    $scope.to = new Date($rootScope.dateRange.end);

    if($rootScope.dateRange.start > $rootScope.dateRange.end){
        $scope.fulldata = [];
    }

    $scope.piechartdataversion = 0;

    $scope.topologies = [
        {name: 'DHCP', label: 'DHCP', splitAccountsOnCache: true, components: [ {name: 'INPUT_FILE_SPOUT', label: 'File source', counters: [
                                                                       {name: 'OUTPUT', unit: 'Number', label: 'Output', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']} ,
                                                                       {name: 'SKIP', unit: 'Number', label: 'Skip', show: ['account']} ] },
                                                    {name: 'PROTOBUF_WRITER_BOLT', label: 'Proto writer', counters: [ {name: 'INPUT', unit: 'Number', label: 'Input', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'INSERT', unit: 'Number', label: 'Insert', show: ['account']},
                                                                       {name: 'UPDATE', unit: 'Number', label: 'Update', show: ['account']},
                                                                       {name: 'DELETE', unit: 'Number', label: 'Delete', show: ['account']},
                                                                       {name: 'SKIP', unit: 'Number', label: 'Skip', show: ['account']},
                                                                       {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']},
                                                                       {name: 'OUTPUT', unit: 'Number', label: 'Output', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'CACHE_SAVE', unit: 'Number', label: 'Cache Save', show: ['cache']},
                                                                       {name: 'CACHE_SUCCESS', unit: 'Number', label: 'Cache Success', show: ['cache']},
                                                                       {name: 'CACHE_COMPACT', unit: 'Number', label: 'Cache Compact', show: ['cache']},
                                                                       {name: 'CACHE_ERROR', unit: 'Number', label: 'Cache Failure', show: ['cache']},
                                                                       {name: 'CACHE_EVICT_TIME', unit: 'Number', label: 'Cache Time', show: ['cache']},
                                                                       {name: 'CACHE_EVICT_SPACE', unit: 'Number', label: 'Cache Space', show: ['cache']}
                                                                       ] } ] },
        {name: 'EVENTS', label: 'Events', components: [ {name: 'INPUT_FILE_SPOUT', label: 'File source', counters: [
                                                                       {name: 'OUTPUT', unit: 'Number', label: 'Output', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']} ,
                                                                       {name: 'SKIP', unit: 'Number', label: 'Skip', show: ['account']} ] },
                                                        {name: 'REDIS_SPOUT', label: 'Redis source', counters: [
                                                                       {name: 'OUTPUT', unit: 'Number', label: 'Output', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']} ,
                                                                       {name: 'SKIP', unit: 'Number', label: 'Skip', show: ['account']} ] },
                                                        {name: 'EVENT_CONVERT_BOLT', label: 'Event Convert', counters: [ {name: 'INPUT', unit: 'Number', label: 'Input', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'INSERT', unit: 'Number', label: 'Insert', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']},
                                                                       {name: 'SKIP', unit: 'Number', label: 'Skip', show: ['account']},
                                                                       {name: 'OUTPUT', unit: 'Number', label: 'Output', show: ['account'], baloonExtraCounter: true}
                                                                       ] },
                                                        {name: 'ELASTICSEARCH_WRITER_BOLT', label: 'ES writer', counters: [ {name: 'INPUT', unit: 'Number', label: 'Input', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'INSERT', unit: 'Number', label: 'Insert', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']},
                                                                       {name: 'CACHE_SAVE', unit: 'Number', label: 'Cache Save', show: ['cache']},
                                                                       {name: 'CACHE_ERROR', unit: 'Number', label: 'Cache Failure', show: ['cache']},
                                                                       {name: 'CACHE_EVICT_SPACE', unit: 'Number', label: 'Cache Space', show: ['cache']},
                                                                       {name: 'CACHE_EVICT_TIME', unit: 'Number', label: 'Cache Time', show: ['cache']}
                                                                       ] },
                                                        {name: 'ALERT_CREATION_BOLT', label: 'Alert creation', counters: [ {name: 'INPUT', unit: 'Number', label: 'Input', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'INSERT', unit: 'Number', label: 'Insert', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']},
                                                                       {name: 'OUTPUT', unit: 'Number', label: 'Output', show: ['account'], baloonExtraCounter: true}
                                                                       ] },
                                                        {name: 'LOGIN_FAILRE_BOLT', label: 'Login failre ', counters: [ {name: 'INPUT', unit: 'Number', label: 'Input', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'INSERT', unit: 'Number', label: 'Insert', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']}
                                                                       ] },
                                                        {name: 'SYSLOG_WRITER_BOLT', label: 'Syslog writer', counters: [ {name: 'INPUT', unit: 'Number', label: 'Input', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'INSERT', unit: 'Number', label: 'Insert', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']}
                                                                       ] } ] },
        {name: 'STATS', label: 'Stats', components: [ {name: 'INPUT_FILE_SPOUT', label: 'File source', counters: [
                                                                       {name: 'OUTPUT', unit: 'Number', label: 'Output', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']} ,
                                                                       {name: 'SKIP', unit: 'Number', label: 'Skip', show: ['account']} ] },
                                                      {name: 'PROTOBUF_WRITER_BOLT', label: 'writer', counters: [ {name: 'INPUT', unit: 'Number', label: 'Input', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'INSERT', unit: 'Number', label: 'Insert', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'INSERT_DUPLICATE', unit: 'Number', label: 'Insert ROOT site', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']},
                                                                       {name: 'SKIP', unit: 'Number', label: 'Skip', show: ['account']},
                                                                       {name: 'OUTPUT', unit: 'Number', label: 'Output', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'CACHE_APPEND', unit: 'Number', label: 'Cache Append', show: ['cache']},
                                                                       {name: 'CACHE_SAVE', unit: 'Number', label: 'Cache Save', show: ['cache']},
                                                                       {name: 'CACHE_SUCCESS', unit: 'Number', label: 'Cache Success', show: ['cache']},
                                                                       {name: 'CACHE_UNCOMPRESS', unit: 'Number', label: 'Cache Uncompress', show: ['cache','static'], baloonExtraCounter: true},
                                                                       {name: 'CACHE_COMPRESS', unit: 'Number', label: 'Cache Compress', show: ['cache','static'], baloonExtraCounter: true},
                                                                       {name: 'CACHE_COMPACT', unit: 'Number', label: 'Cache Compact', show: ['cache'], baloonExtraCounter: true},
                                                                       {name: 'CACHE_ERROR', unit: 'Number', label: 'Cache Failure', show: ['cache']},
                                                                       {name: 'CACHE_EVICT_TIME', unit: 'Number', label: 'Cache Time', show: ['cache']},
                                                                       {name: 'CACHE_EVICT_SPACE', unit: 'Number', label: 'Cache Space', show: ['cache']}]}]},
        {name: 'NEW_STATS', label: 'NewStats', components: [ {name: 'INPUT_FILE_SPOUT', label: 'File source', counters: [
                                                                       {name: 'OUTPUT', unit: 'Number', label: 'Output', show: ['account'], baloonExtraCounter: true},
                                                                       {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']} ,
                                                                       {name: 'SKIP', unit: 'Number', label: 'Skip', show: ['account']} ] },
                                                      {name: 'PROTOBUF_WRITER_BOLT', label: 'writer', counters: [ {name: 'INPUT', unit: 'Number', label: 'Input', show: ['account'], baloonExtraCounter: true},
                                                                                                                             {name: 'INSERT', unit: 'Number', label: 'Insert', show: ['account'], baloonExtraCounter: true},
                                                                                                                             {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']},
                                                                                                                             {name: 'SKIP', unit: 'Number', label: 'Skip', show: ['account']},
                                                                                                                             {name: 'OUTPUT', unit: 'Number', label: 'Output', show: ['account'], baloonExtraCounter: true},
                                                                                                                             {name: 'CRC_CACHE_APPEND', unit: 'Number', label: 'CRC Cache Size', show: ['account']},
                                                                                                                             {name: 'CRC_CACHE_TOTAL_SIZE', unit: 'Number', label: 'CRC Cache Append', show: ['account']},
                                                                                                                             {name: 'CRC_CACHE_FREE_DAY', unit: 'Number', label: 'CRC Cache Evict', show: ['account']},
                                                                                                                             {name: 'CACHE_APPEND', unit: 'Number', label: 'Cache Append', show: ['cache']},
                                                                                                                             {name: 'CACHE_SAVE', unit: 'Number', label: 'Cache Save', show: ['cache']},
                                                                                                                             {name: 'CACHE_SUCCESS', unit: 'Number', label: 'Cache Success', show: ['cache']},
                                                                                                                             {name: 'CACHE_UNCOMPRESS', unit: 'Number', label: 'Cache Uncompress', show: ['cache','static'], baloonExtraCounter: true},
                                                                                                                             {name: 'CACHE_COMPRESS', unit: 'Number', label: 'Cache Compress', show: ['cache','static'], baloonExtraCounter: true},
                                                                                                                             {name: 'CACHE_COMPACT', unit: 'Number', label: 'Cache Compact', show: ['cache'], baloonExtraCounter: true},
                                                                                                                             {name: 'CACHE_ERROR', unit: 'Number', label: 'Cache Failure', show: ['cache']},
                                                                                                                             {name: 'CACHE_EVICT_TIME', unit: 'Number', label: 'Cache Time', show: ['cache']},
                                                                                                                             {name: 'CACHE_EVICT_SPACE', unit: 'Number', label: 'Cache Space', show: ['cache']}]}] },
        {name: 'CONNECTIVITY', label: 'Connectivity', splitAccountsOnCache: true,  components: [ {name: 'INPUT_FILE_SPOUT', label: 'File source', counters: [
                                                                               {name: 'OUTPUT', unit: 'Number', label: 'Output', show: ['account'], baloonExtraCounter: true},
                                                                               {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']} ,
                                                                               {name: 'SKIP', unit: 'Number', label: 'Skip', show: ['account']} ] },
                                                              {name: 'PROTOBUF_WRITER_BOLT', label: 'Proto writer', counters: [ {name: 'INPUT', unit: 'Number', label: 'Input', show: ['account'], baloonExtraCounter: true},
                                                                               {name: 'INSERT', unit: 'Number', label: 'Insert', show: ['account'], baloonExtraCounter: true},
                                                                               {name: 'UPDATE', unit: 'Number', label: 'Update', show: ['account']},
                                                                               {name: 'DELETE', unit: 'Number', label: 'Delete', show: ['account']},
                                                                               {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']},
                                                                               {name: 'SKIP', unit: 'Number', label: 'Skip', show: ['account']},
                                                                               {name: 'OUTPUT', unit: 'Number', label: 'Output', show: ['account'], baloonExtraCounter: true},
                                                                               {name: 'CACHE_APPEND', unit: 'Number', label: 'Target Cache Append', show: ['cache']},
                                                                               {name: 'CACHE_SAVE', unit: 'Number', label: 'Target Cache Save', show: ['cache']},
                                                                               {name: 'CONN_CACHE_EVICT_TAR_TIMER', unit: 'Number', label: 'Target Cache Timer', show: ['cache']},
                                                                               {name: 'CONN_CACHE_EVICT_TAR_HOST', unit: 'Number', label: 'Target Cache Host Done', show: ['cache']},
                                                                               {name: 'CONN_CACHE_EVICT_HOST_DONE', unit: 'Number', label: 'Cache Host Done', show: ['cache']},
                                                                               {name: 'CONN_CACHE_EVICT_HOST_EOD', unit: 'Number', label: 'Cache Host EOD', show: ['cache']},
                                                                               {name: 'CONN_CACHE_EVICT_HOST_SPACE', unit: 'Number', label: 'Cache Host Space', show: ['cache']},
                                                                               {name: 'CONN_CACHE_EVICT_HOST_TIMER', unit: 'Number', label: 'Cache Host Time', show: ['cache']},
                                                                               {name: 'CONN_CACHE_HOST_COLD_HIT', unit: 'Number', label: 'Cache Host Cold Hit', show: ['cache']},
                                                                               {name: 'CONN_CACHE_EVICT_FLOW_TIMER', unit: 'Number', label: 'Cache Flow Time', show: ['cache']},
                                                                               {name: 'CONN_CACHE_FLOW_COLD_HIT', unit: 'Number', label: 'Cache Flow Cold Hit', show: ['cache']},
                                                                               {name: 'CONN_CACHE_FLOW_DROPPED', unit: 'Number', label: 'Dropped Flow', show: ['cache']},
                                                                               {name: 'CACHE_SUCCESS', unit: 'Number', label: 'Cache Success', show: ['cache']},
                                                                               {name: 'CACHE_ERROR', unit: 'Number', label: 'Cache Failure', show: ['cache']}  ] }] },
        {name: 'TRAFFIC', label: 'Traffic', splitAccountsOnCache: true,  components: [ {name: 'INPUT_FILE_SPOUT', label: 'File source', counters: [
                                                                               {name: 'OUTPUT', unit: 'Number', label: 'Output', show: ['account'], baloonExtraCounter: true},
                                                                               {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']} ,
                                                                               {name: 'SKIP', unit: 'Number', label: 'Skip', show: ['account']} ] },
                                                              {name: 'TRAFFIC_WRITER_BOLT', label: 'Pcap writer', counters: [ {name: 'INPUT', unit: 'Number', label: 'Input', show: ['account'], baloonExtraCounter: true},
                                                                               {name: 'INSERT', unit: 'Number', label: 'Insert', show: ['account'], baloonExtraCounter: true},
                                                                               {name: 'ERROR', unit: 'Number', label: 'Error', show: ['account']},
                                                                               {name: 'OUTPUT', unit: 'Number', label: 'Output', show: ['account'], baloonExtraCounter: true},
                                                                               {name: 'CACHE_APPEND', unit: 'Number', label: 'Target Cache Append', show: ['cache']},
                                                                               {name: 'CACHE_SAVE', unit: 'Number', label: 'Target Cache Save', show: ['cache']},
                                                                               {name: 'CACHE_SUCCESS', unit: 'Number', label: 'Cache Success', show: ['cache']},
                                                                               {name: 'CACHE_ERROR', unit: 'Number', label: 'Cache Failure', show: ['cache']} ,
                                                                               {name: 'CACHE_EVICT_TIME', unit: 'Number', label: 'Cache Time', show: ['cache']},
                                                                               {name: 'CACHE_EVICT_SPACE', unit: 'Number', label: 'Cache Space', show: ['cache']}]}] },
        {name: 'REALTIME', label: 'Real Time', components: [ {name: 'PUSH_JOB', label: 'Push Job', counters: [
                                                                       {name: 'REALTIME_FULL_UPDATE_POP', unit: 'Number', label: 'Full Pop Update', show: ['pop'], baloonExtraCounter: true},
                                                                       {name: 'REALTIME_PARTIAL_UPDATE_POP', unit: 'Number', label: 'Partial Pop Update', show: ['pop'], baloonExtraCounter: true},
                                                                       {name: 'REALTIME_UPDATE_ACCOUNT', unit: 'Number', label: 'Account Update', show: ['account']} ,
                                                                       {name: 'REALTIME_UPDATE_ESTABLISHED_ACCOUNT', unit: 'Number', label: 'Established Tunnel Update', show: ['account']} ,
                                                                       {name: 'REALTIME_UPDATE_TEARING_DOWN_ACCOUNT', unit: 'Number', label: 'Tearing Down Tunnel Update', show: ['account']} ,
                                                                       {name: 'SYNC_POP', unit: 'Number', label: 'Sync Pop', show: ['pop']},
                                                                       {name: 'CLEAN_ACCOUNT', unit: 'Number', label: 'Clean Account', show: ['account']}] } ] }
    ];

    $scope.currenttopology = $scope.topologies[0];
    $scope.components = $scope.currenttopology.components;
    $scope.currentcomponent = $scope.components[0];
    $scope.counters = $scope.currentcomponent.counters;
    $scope.currentcounter = $scope.counters[0];

    $scope.$watch('start', function(newValue, oldValue) {
        if (newValue && !_.isEqual(newValue, oldValue)) {
            if($rootScope.dateRange.start > $rootScope.dateRange.end){
                $scope.fulldata = [];
                $scope.metricdata = [];
                $scope.filtereddata = [];
            }
            else {
                $scope.from = new Date($rootScope.dateRange.start);
                $scope.to = new Date($rootScope.dateRange.end);
            }
            getProcessingDataByDates();
        }
    });

    $scope.$watch('end', function(newValue, oldValue) {
        if (newValue && !_.isEqual(newValue, oldValue)) {
            if($rootScope.dateRange.start > $rootScope.dateRange.end){
                $scope.fulldata = [];
                $scope.metricdata = [];
                $scope.filtereddata = [];
            }
            else {
                $scope.from = new Date($rootScope.dateRange.start);
                $scope.to = new Date($rootScope.dateRange.end);
            }
            getProcessingDataByDates();
        }
    });

    $scope.$watch('from', function(newValue, oldValue) {
        if (!_.isEqual(newValue, oldValue)) {
            $location.search('from',newValue.getTime());
            getProcessingDataByDates();
        }
    }, true);

    $scope.$watch('to', function(newValue, oldValue) {
        if (!_.isEqual(newValue, oldValue)) {
            $location.search('to',newValue.getTime());
            getProcessingDataByDates();
        }
    });

    $scope.entityclick = function(row){
        if (row.id != "All Accounts" && row.id != "All Pops" ){
            if ($scope.curEntity== row.id){
            $scope.curEntity = null;
                $scope.filtereddata = [];
            }
            else{
                $scope.curEntity = row.id;
                getProcessingDataByDates(row.id);
            }
        }
    };

    $scope.processingDataCollection = store.addCollection({path: '/getComponentsMetricData' });

    var getProcessingDataByDates = function(entityId) {
        var filter;
        if (entityId){
            filter = true;
        }

        var fromDate = $scope.from ? $scope.from.getTime() : $rootScope.dateRange.start;
        var toDate = $scope.to ? $scope.to.getTime() : $rootScope.dateRange.end;
        if(toDate && fromDate){
            var newInterval = Math.floor((toDate - fromDate) / 50);
            if(newInterval > 1800000){ // when the chosen interval is smaller ~ when 30 min, will get the data in resolution of 5 min to allow scrolling
                $scope.graphinterval = newInterval;
            }
            else {
                $scope.graphinterval = 300000;
            }
        }

        var path = "/getComponentsMetricData";
            $('#infovis').show();



        $scope.processingDataCollection.fetch({
            defer: 1000,
            path: path,
            filter: true,
            queryParams: {
                topologyName : $scope.currenttopology.name,
                fromDate: fromDate,
                toDate: toDate,
                interval: $scope.graphinterval,
                entityId : (entityId) ? entityId : null,
                time: fromDate
            },
            error: function (){
            },
            success: function (data) {
                if (data.metricData) {
                    if (filter){
                        $scope.filtereddata =  processMetricData(data);

                    }
                    else{
                        $scope.fulldata = data;
                        $scope.metricdata = processMetricData($scope.fulldata);
                    }
                }
                $scope.piechartdataversion = new Date().getTime();
            }
        });
    };

    function processMetricData(data){
        if (data && data.metricData){
            var metricData = $.map(data.metricData, function(value, index) {
                return [value];
            });
            metricData = _.sortBy(metricData, 'dateTime');
            //update metric data - the main graph data
            for (var i = 0; metricData[i]; i++) {
                metricData[i].dateTime = new Date(metricData[i].dateTime);
                metricData[i].lineColor = "#FF6600";
                metricData[i].alphaField = 1;

                if(metricData[i].metrics &&  metricData[i].metrics[$scope.currenttopology.name+$scope.currentcomponent.name+$scope.currentcounter.name]){
                    metricData[i].size = metricData[i].metrics[$scope.currenttopology.name+$scope.currentcomponent.name+$scope.currentcounter.name];
                    if ($scope.currentcounter.baloonExtraCounter) {
                        var bytesSize = metricData[i].metrics[$scope.currenttopology.name+$scope.currentcomponent.name+$scope.currentcounter.name+"_SIZE"];
                        var precession = metricData[i].metrics[$scope.currenttopology.name+$scope.currentcomponent.name+$scope.currentcounter.name] > 1 ? 0 : 2;
                        metricData[i].label = $filter('number')(metricData[i].metrics[$scope.currenttopology.name+$scope.currentcomponent.name+$scope.currentcounter.name],precession) + " ("+$filter('bytes')(bytesSize,2)+"/sec)";
                    }
                }
                else {
                    metricData[i].size = 0;
                }
            }
            return metricData;
        }
    }

    function updateAccountFields(entityName){
           var fields = updateEntityFields('account');
           if(fields.length > 1){
            $scope.accountsfields = fields
            $scope.showaccount = true;
           }
           else{
            $scope.showaccount = false;
           }
    }

     function updatePopFields(entityName){
            var fields = updateEntityFields('pop');
            if(fields.length > 1){
             $scope.popsfields = fields
             $scope.showpop = true;
            }
            else{
             $scope.showpop = false;
            }
     }

    function updateEntityFields(entityName){
        //update pie fields to hold all the topology counter
        var entitiesfields = [ {"label":  $filter('capitalize')(entityName)+ " Id", "path": "id","template":"{{item.id}}"}];

        for(var componentId in $scope.currenttopology.components){
            var component = $scope.currenttopology.components[componentId];
            for(var counterId in component.counters){
                var counter = component.counters[counterId];
                if (counter.show.indexOf(entityName) > -1){
                    entitiesfields.push({"label": component.label + " (" + counter.label + ")" , "path": component.name+counter.name , "template": "{{item." + component.name+counter.name + "}}"});
                }
            }
        }
        return entitiesfields;
    }

    function updateCacheFields(){
        //update pie fields to hold all the topology counter
        var cachefields = [ {"label" : "Account", "path": "account" ,"template":"{{item.account}}"}, {"label" : "Component", "path": "id" ,"template":"{{item.id}}"}];
        var cacheIdList = [];
        for(var componentId in $scope.currenttopology.components){
            var component = $scope.currenttopology.components[componentId];
            for(var counterId in component.counters){
                var counter = component.counters[counterId];
                if (counter.show.indexOf('cache') > -1 && cacheIdList.indexOf(counter.name) == -1){
                    cachefields.push({"label": counter.label, "path": counter.name, "template": "{{item." +counter.name +"}}"});
                    cacheIdList.push(counter.name);
                }
            }
        }
        $scope.cachefields = cachefields;
        if(cacheIdList.length > 0){
            $scope.showcache = true;
        }
        else{
            $scope.showcache = false;
        }
    }

    $scope.processAccountData = function(){
        return $scope.processEntityData('account');
    }

    $scope.processPopData = function(){
        return $scope.processEntityData('pop');
    }

    $scope.processEntityData = function(entityName){
        //update pie data
        var entitiesData = [];
        for (var attr in $scope.fulldata.entitiesData) {
        var entitiesDataValue = {"id":attr, "size": 0};
            var foundAccount = false;
            for(var componentId in $scope.currenttopology.components){
                var component = $scope.currenttopology.components[componentId];
                for(var counterId in component.counters){
                    var counter = component.counters[counterId];
                    if (counter.show.indexOf(entityName) > -1){
                        if (($scope.fulldata.entitiesData[attr][$scope.currenttopology.name+component.name+counter.name]) && ($scope.fulldata.entitiesData[attr][$scope.currenttopology.name+component.name+counter.name]) > 0){
                                entitiesDataValue[component.name+counter.name] = $scope.fulldata.entitiesData[attr][$scope.currenttopology.name+component.name+counter.name];
                                foundAccount = true;
                        }
                        else{
                            entitiesDataValue[component.name+counter.name] = 0;
                        }
                    }
                }
            }
            if(foundAccount){
               if (attr != "-1"){
                    if($scope.fulldata.entitiesData[attr] && $scope.fulldata.entitiesData[attr][$scope.currenttopology.name+$scope.currentcomponent.name+$scope.currentcounter.name]){
                        entitiesDataValue["size"] = $scope.fulldata.entitiesData[attr][$scope.currenttopology.name+$scope.currentcomponent.name+$scope.currentcounter.name]
                    }
                }
                else{
                    entitiesDataValue["id"] = "All " + $filter('capitalize')(entityName) + "s";
                }
                entitiesData.push(entitiesDataValue);
            }
        }
        return entitiesData;
    }

    $scope.processCacheData = function(){
        //update pie data
        var cacheData = [];
        var splitAccountsOnCache = $scope.currenttopology.splitAccountsOnCache;
        var mainAccount = $scope.fulldata.entitiesData["0"];
        if(mainAccount && !splitAccountsOnCache){
            // Show cache data only on all account
            processCacheDataForAccount("0", mainAccount, cacheData, true);
        } else {
            // show cache data for each account separately
            for (var mainAccountId in $scope.fulldata.entitiesData) {
                if (mainAccountId == "-1" || mainAccountId == "General") {
                    continue;
                }
                var mainAccount = $scope.fulldata.entitiesData[mainAccountId];
                processCacheDataForAccount(mainAccountId, mainAccount, cacheData, false);
            }
        }
        return cacheData;
    };

    function processCacheDataForAccount(mainAccountId, mainAccount, cacheData, assumeAllAccount){
        // go over components of account and check if component contains cache counters
       for(var componentId in $scope.currenttopology.components){
            var component = $scope.currenttopology.components[componentId];
            let cacheDataValue = {"id": component.label, "account": mainAccountId == "0" && assumeAllAccount ? "All Accounts" : mainAccountId};
            var foundCache = false;
            for(var counterId in component.counters){
                var counter = component.counters[counterId];
                if (counter.show.indexOf('cache') > -1){
                    cacheDataValue[counter.name] = (mainAccount[$scope.currenttopology.name+component.name+counter.name]) ?  mainAccount[$scope.currenttopology.name+component.name+counter.name] : 0;
                    if (counter.baloonExtraCounter){
                        var bytesSize = $filter('bytes')(mainAccount[$scope.currenttopology.name+component.name+counter.name+"_SIZE"],2);
                        if (cacheDataValue[counter.name] != 0){
                            cacheDataValue[counter.name] = cacheDataValue[counter.name] + " ("+bytesSize+")";
                        }
                        else{
                            cacheDataValue[counter.name] = bytesSize;
                        }
                    }
                    foundCache = true;
                }
            }
            if (foundCache){
                cacheData.push(cacheDataValue);
            }
        }
    }

    $scope.changeTopology = function(){
        $location.search('currenttopologyname',$scope.currenttopology.name);
        $scope.components = $scope.currenttopology.components;
        $scope.currentcomponent = $scope.components[0];
        $scope.counters = $scope.currentcomponent.counters;
        $scope.currentcounter = $scope.counters[0];
        updateAccountFields();
        updatePopFields();
        updateCacheFields();
        getProcessingDataByDates();
        $scope.changeComponent()
    };

    $scope.changeComponent = function(){
        $location.search('currentcomponentname',$scope.currentcomponent.name);
        $scope.counters = $scope.currentcomponent.counters.filter(function(value, index) { return value.show.indexOf('static') == -1 });
        $scope.currentcounter = $scope.counters[0];
        $scope.changeCounter();
    };

    $scope.changeCounter = function(){
        $location.search('currentcountername',$scope.currentcounter.name);
        $scope.metricdata = processMetricData($scope.fulldata);
        $scope.piechartdataversion = new Date().getTime();
    };

    $scope.$on('$routeChangeSuccess', function ($event, current) {
        var refreshData = false;
        if (current.params.currenttopologyname){
            var currenttopology = $scope.topologies.filter(function(value, index) { return value.name == current.params.currenttopologyname });
            if($scope.currenttopology !== currenttopology[0]){
                $scope.currenttopology = currenttopology[0];
                $scope.components = $scope.currenttopology.components;
                refreshData = true;
            }
        }
        if (current.params.currentcomponentname){
            var currentcomponent = $scope.components.filter(function(value, index) { return value.name == current.params.currentcomponentname });
            if($scope.currentcomponent !== currentcomponent[0]){
                $scope.currentcomponent = currentcomponent[0];
                $scope.counters = $scope.currentcomponent.counters;
                refreshData = true;
            }
        }
        if (current.params.currentcountername){
            var currentcounter = $scope.counters.filter(function(value, index) { return value.name == current.params.currentcountername });
            if ($scope.currentcounter !== currentcounter[0]){
                $scope.currentcounter = currentcounter[0];
                $scope.metricdata = processMetricData($scope.fulldata);
                refreshData = true;
            }
        }
        if (current.params.start && Number(current.params.start) != $rootScope.dateRange.start){
            $rootScope.dateRange.start = Number(current.params.start);
            refreshData = true;
        }
        if (current.params.end && Number(current.params.end) != $rootScope.dateRange.end){
            $rootScope.dateRange.end = Number(current.params.end);
            refreshData = true;
        }
        if (current.params.from && Number(current.params.from) != $scope.from.getTime()){
            $scope.from = new Date(Number(current.params.from));
            refreshData = true;
        }
        if (current.params.to && Number(current.params.to) != $scope.to.getTime()){
            $scope.to = new Date(Number(current.params.to));
            refreshData = true;
        }
        if(refreshData === true){
            updateAccountFields();
            updatePopFields();
            updateCacheFields();
            getProcessingDataByDates();
        }
    });

    $scope.$on('$destroy',function(){
    });

    updateAccountFields();
    updatePopFields();
    updateCacheFields();
    getProcessingDataByDates();



}